import React from 'react'
import { getFileIcon, formatFileSize } from '../../../utils/formatHelpers'

interface ProductFilesUploaderProps {
  files: File[]
  filesUploading: boolean
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onRemove: (index: number) => void
}

const ProductFilesUploader: React.FC<ProductFilesUploaderProps> = ({
  files,
  filesUploading,
  onChange,
  onRemove
}) => {
  return (
    <div className='product-files-uploader'>
      <div className='form-group mb-3'>
        <label htmlFor='files'>Pliki do pobrania</label>
        <input
          type='file'
          className='form-control-file'
          id='files'
          name='files'
          multiple
          onChange={onChange}
          disabled={filesUploading}
        />
        <small className='form-text text-muted'>
          Wybierz pliki, które będą dostępne do pobrania po zakupie produktu.
        </small>
      </div>

      {files.length > 0 && (
        <div className='files-preview mt-3'>
          {files?.map((file, index) => (
            <div key={index} className='file-item d-flex align-items-center mb-2'>
              <i className={`fa ${getFileIcon(file.type)} me-2`} />
              <span className='me-2'>{file.name}</span>
              {/* <span className="text-muted me-2">({formatFileSize(file.size)})</span> */}
              <button
                type='button'
                className='btn btn-sm btn-outline-danger'
                onClick={() => onRemove(index)}
              >
                <i className='fa fa-times' />
              </button>
            </div>
          ))}
        </div>
      )}

      {filesUploading && (
        <div className='mt-2'>
          <span className='spinner-border spinner-border-sm me-2' role='status' aria-hidden='true' />
          Przesyłanie plików...
        </div>
      )}
    </div>
  )
}

export default ProductFilesUploader
